// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3elZP{border-bottom:1px solid #e0e8f2;margin-bottom:3rem;padding:0 2.4rem 3rem}._1TOzu{color:#452aec;display:block;font-size:16px;font-size:1.6rem}._2ieLb{height:16px;height:1.6rem;margin-right:2rem;position:relative;stroke:#452aec;top:2px;width:16px;width:1.6rem}html[dir=rtl] ._2ieLb{-webkit-transform:rotate(180deg);-ms-transform:rotate(180deg);transform:rotate(180deg)}._3elZP:hover ._1TOzu{color:#001f5b}._3elZP:hover ._2ieLb{stroke:#001f5b}", ""]);
// Exports
exports.locals = {
	"backButton": "_3elZP",
	"backButton__link": "_1TOzu",
	"backButton__arrow": "_2ieLb"
};
module.exports = exports;
